import GameOverviewRules from "../../rules/GameOverviewRules/GameOverviewRules";
import KeyPointsRules from "../../rules/KeyPointsRules/KeyPointsRules";
import ConstructionPhaseRules from "../../rules/ConstructionPhaseRules/ConstructionPhaseRules";
import SupplyPhaseRules from "../../rules/SupplyPhaseRules/SupplyPhaseRules";
import UnitsRules from "../../rules/UnitsRules/UnitsRules";
import WarPhaseRules from "../../rules/WarPhaseRules/WarPhaseRules";
import IncomeRules from "../../rules/IncomeRules/IncomeRules";
import ScoringRules from "../../rules/ScoringRules/ScoringRules";
import PoliciesRules from "../../rules/PoliciesRules/PoliciesRules";
import FactionsRules from "../../rules/FactionsRules/FactionsRules";
import InterfaceRules from "../../rules/InterfaceRules/InterfaceRules";
import AdvancedRules from "../../rules/AdvancedRules/AdvancedRules";
import BotsRules from "../../rules/BotsRules/BotsRules";
import RankedRules from "../../rules/RankedRules/RankedRules";
import {RULES_SECTION_IDS} from "./rulesSectionIds";

// Идентификаторы разделов — в отдельном модуле: на них ссылаются и сами
// страницы правил (RulesSectionLink), а этот модуль импортирует страницы
export {RULES_SECTION_IDS};

// Разделы правил для бокового меню RulesModal — по аналогии с game_rules.md.
// Каждый раздел — отдельный компонент, показывающий контент выбранной страницы.
// iconSrc — значок на плашке раздела в боковой панели; у обзорного раздела и
// раздела для опытных игроков своего значка нет, место под него все равно
// резервируется, чтобы подписи всех плашек шли по одной вертикали
export const RULES_SECTIONS = [
  {id: RULES_SECTION_IDS.OVERVIEW, label: 'Обзор игры', Component: GameOverviewRules},
  {
    id: RULES_SECTION_IDS.KEY_POINTS,
    label: 'Ключевые точки',
    Component: KeyPointsRules,
    iconSrc: '/img/hexes/key point.1479d53f.png',
  },
  {
    id: RULES_SECTION_IDS.CONSTRUCTION_PHASE,
    label: 'Фаза Строительства',
    Component: ConstructionPhaseRules,
    iconSrc: '/img/icons/hammer brown.png',
  },
  {
    id: RULES_SECTION_IDS.SUPPLY_PHASE,
    label: 'Фаза Снабжения',
    Component: SupplyPhaseRules,
    iconSrc: '/img/icons/supply.png',
  },
  {
    id: RULES_SECTION_IDS.WAR_PHASE,
    label: 'Фаза Войны',
    Component: WarPhaseRules,
    iconSrc: '/img/icons/barracks red.png',
  },
  {
    id: RULES_SECTION_IDS.UNITS,
    label: 'Отряды',
    Component: UnitsRules,
    iconSrc: '/img/icons/unit d6 friend.png',
    iconClassName: 'rules-modal_legend-icon_unit'
  },
  {
    id: RULES_SECTION_IDS.INCOME,
    label: 'Доход',
    Component: IncomeRules,
    iconSrc: '/img/icons/coins.png',
  },
  {
    id: RULES_SECTION_IDS.SCORING,
    label: 'Очки за действия',
    Component: ScoringRules,
    iconSrc: '/img/icons/win points.png',
  },
  {
    id: RULES_SECTION_IDS.FACTIONS,
    label: 'Фракции',
    Component: FactionsRules,
    iconSrc: '/img/icons/banner.png',
    // Знамя нарисовано тем же PRIMARY_COLOR, что и фон выбранной плашки —
    // без этого класса значок сливается с ней (см. CSS по этому имени)
    iconClassName: 'rules-modal_sections-panel_link-icon_banner',
  },
  {
    id: RULES_SECTION_IDS.POLICIES,
    label: 'Политики',
    Component: PoliciesRules,
    iconSrc: '/img/icons/governance.png',
  },
  {
    // Рейтинг и явные боты рейтинговых матчей; сюда же ведет ссылка с экрана
    // настройки поиска рейтингового матча
    id: RULES_SECTION_IDS.RANKED,
    label: 'Рейтинг',
    Component: RankedRules,
    iconSrc: '/img/icons/star_rating.png',
  },
  {
    id: RULES_SECTION_IDS.BOTS,
    label: 'Боты',
    Component: BotsRules,
    // Плашка темная — значок без черного контура (на светлой странице раздела
    // стоит контурный, см. BotsRules)
    iconSrc: '/img/icons/bot_gold.png',
  },
  {
    id: RULES_SECTION_IDS.ADVANCED,
    label: 'Для опытных игроков',
    Component: AdvancedRules,
    iconSrc: '/img/icons/first place.png',
  },
  {
    id: RULES_SECTION_IDS.INTERFACE,
    label: 'Интерфейс',
    Component: InterfaceRules,
    iconSrc: '/img/icons/free action.png',
  },
];

export const DEFAULT_RULES_SECTION_ID = RULES_SECTION_IDS.OVERVIEW;
